import { FC } from 'react';
import { CustomerAccountErrorImageProps } from '../../types';

export const CustomerAccountErrorImage: FC<CustomerAccountErrorImageProps> = ({
  image,
  alt,
  classname
}) => <img alt={alt} src={image} loading="lazy" className={classname} />;
